// Sempozyum geneli paylaşılan, dile bağlı OLMAYAN veriler.
// Çevrilebilir tüm metinler messages/tr.json ve messages/en.json dosyalarındadır.

export const site = {
  startDate: "2026-07-13",
  endDate: "2026-07-15",
  email: "dpustudentcongress@gmail.com",
  url: "https://egitim40-sempozyum.vercel.app", // yayın adresi
  applicationFormUrl:
    "https://docs.google.com/forms/d/e/1FAIpQLScTNM7X-J_M3KbiR9Fs_1DvETh4TTUM3Nk2276CANML_1dTwQ/viewform",
} as const;

export type NavItem = {
  key: string; // messages -> nav.<key>
  href: string;
};

// Üst sekme navigasyonu — etiketler çeviri dosyalarından gelir
export const nav: NavItem[] = [
  { key: "home", href: "/" },
  { key: "purpose", href: "/amac" },
  { key: "boards", href: "/kurullar" },
  { key: "program", href: "/program" },
  { key: "strengths", href: "/guclu-yanlar" },
  { key: "application", href: "/basvuru" },
  { key: "why", href: "/neden-katilmali" },
  { key: "venue", href: "/mekan-ulasim" },
  { key: "guide", href: "/kutahya-rehberi" },
  { key: "contact", href: "/iletisim" },
];

// Mekân harita bağlantıları (dil bağımsız)
export const venueMaps: string[] = [
  "https://www.google.com/maps/search/?api=1&query=K%C3%BCtahya%20%C3%87ini%20M%C3%BCzesi",
  "https://www.google.com/maps/search/?api=1&query=K%C3%BCtahya%20Arkeoloji%20M%C3%BCzesi%20Vacidiye%20Medresesi",
];

// Kaynak bağlantıları (dil bağımsız etiket + URL)
export const sources: [string, string][] = [
  [
    "Kütahya İl Kültür ve Turizm Müdürlüğü - Çini Müzesi",
    "https://kutahya.ktb.gov.tr/TR-69423/cini-muzesi.html",
  ],
  [
    "Kütahya İl Kültür ve Turizm Müdürlüğü - Arkeoloji Müzesi",
    "https://kutahya.ktb.gov.tr/TR-69422/arkeoloji-muzesi.html",
  ],
  [
    "TDV İslâm Ansiklopedisi - Vacidiye Medresesi",
    "https://islamansiklopedisi.org.tr/vacidiye-medresesi",
  ],
  ["Zafer Havalimanı - Uçuş Bilgileri", "https://www.zafer.aero/TR/ucusBilgileri"],
  [
    "Zafer Havalimanı - Şehir İçi Servisler",
    "https://www.zafer.aero/TR/page/sehir-ici-servisler-ve-arac-kiralama-41",
  ],
  ["TCDD Taşımacılık E-Bilet", "https://ebilet.tcddtasimacilik.gov.tr/"],
  [
    "Rail Turkey - Eskişehir Kütahya Treni",
    "https://tr.railturkey.org/seyahat/trenler/bolgesel/eskisehirkutahya/",
  ],
  [
    "UNESCO Creative Cities Network - Kütahya",
    "https://www.unesco.org/en/creative-cities/kutahya",
  ],
  ["GoTürkiye - Kütahya Rotaları", "https://kutahya.goturkiye.com/tr-tr/kutahya-rotalari"],
  [
    "Kültür Portalı - Kütahya Kalesi",
    "https://www.kulturportali.gov.tr/turkiye/kutahya/gezilecekyer/kutahya-kales",
  ],
  [
    "Kültür Portalı - Aizanoi Antik Kenti",
    "https://kulturportali.gov.tr/turkiye/kutahya/gezilecekyer/azano-antk-kent",
  ],
];
